import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import type { IssueInDto } from 'shared/dtos/in/issue';
import {
  broadcastCreatedIssue,
  broadcastDeletedIssue,
  broadcastUpdatedIssue,
} from 'serviceWorker/broadcasts/issues';
import { broadcastIssueError } from '../errorHandlers';
import { issueRequestDataOf } from '../issue/issueRequestData';
import { isIssueRestoreRequest } from 'serviceWorker/services/issues/changeIssueArchival';
import { projectIdOfRequest } from 'serviceWorker/helpers/dataScope';

/** What the issue runner answers: the saved issue, or the server's error. */
type IssueResponse = IssueInDto & { error?: unknown };

/** Answers the issue change with the request's `uniqueId`, so the page waiting for it gets the outcome. */
export function broadcastIssueResponse(
  request: HttpRequestEntity,
  response: IssueResponse
): void {
  if (response.error) {
    return broadcastIssueError(request, response.error);
  }

  const { uniqueId, issueId } = issueRequestDataOf(request);
  const projectId = projectIdOfRequest(request);
  if (isIssueRestoreRequest(request)) {
    // A restore answers the restored issue, like an edit.
    return void broadcastUpdatedIssue(response, uniqueId, projectId);
  }
  switch (request.method) {
    case 'POST':
      return void broadcastCreatedIssue(response, uniqueId, projectId);
    case 'DELETE':
      if (issueId) {
        return void broadcastDeletedIssue(issueId, uniqueId, projectId);
      }
      return;
    default:
      return void broadcastUpdatedIssue(response, uniqueId, projectId);
  }
}
